// extracted by mini-css-extract-plugin
module.exports = {"grid":"-kpArGPu fixed top-0 left-0 right-0 bottom-0","column":"_1SMv0BXg flex items-center justify-center"};